import StoreService from "../classes/StoreService";

export function formProgressSync(formEl, formSyncId) {
  if (!formEl) {
    throw Error("Form El is required");
  }

  // RESTORE FORM PROGRESS IF IT EXISTS ON PAGE LOAD

  const inputs = formEl.querySelectorAll("input:not([datepicker])"); // EXCLUDE DATEPICKER INPUTS
  const textareas = formEl.querySelectorAll("textarea");
  const selects = formEl.querySelectorAll("select");
  // SELECT ONLY DATEPICKER AND CUSTOM DATEPICKERS INPUTS (DATEPICKERS CREATED WITH JS)
  const datepickerEls = formEl.querySelectorAll(
    "input[datepicker], input[data-datepicker]"
  );

  restoreFormProgress(formSyncId);

  // ENABLE FORM PROGRESS AUTOSAVE FOR INPUT ELEMENTS
  // console.log([...inputs, ...selects]);
  saveFormProgress(
    formSyncId,
    [...inputs, ...selects, ...textareas],
    datepickerEls
  );
  // RESTORE FORM PROGRESS IF IT EXISTS ON PAGE LOAD END
}

// RESTORE FORM POGRESS FROM LS
export function restoreFormProgress(formId) {
  if (formId) {
    const data = StoreService.get(formId);
    // console.log({ data });
    for (const [key, value] of Object.entries(data)) {
      const el = $(`[name="${key}"]`);
      // console.log(el, data, el.prop("type"));
      el.val(value);
      // IF IT'S A SELECT ELEMENT, WE NEED TO TRIGGER CHANGE EVENT FOR THE DATA TO DISPLAY
      // THE TYPE OF SELECT2 IS "select-one" SO I'M USING STARTWITH BECAUSE I DON'T KNOW IF THAT'LL CHANGE SOON
      if (el.prop("type")?.startsWith("select")) el.trigger("change");
    }
  } else {
    throw Error("formId is required to restore a form progress");
  }
}

// SAVE PROGRESS TO LS
export function saveFormProgress(formId, elements = [], datepickerEls = []) {
  if (formId) {
    // SET ONCHANAGE EVENF FOR ALL INPUTS
    elements.forEach(function (el) {
      const ignoredInputs = ["file", "checkbox", "hidden"];
      if (!ignoredInputs.includes(el.type)) {
        $(el).on("change", function () {
          const data = StoreService.get(formId);
          // console.log(data[el.name], $(this).val());
          data[el.name] = $(this).val();
          // console.log({ proposedSavedData: data });
          StoreService.save(formId, data);
          // console.log({ savedData: StoreService.get(formId) });
        });
      }
    });

    // FLOWBITE DATEPICKER EL DOES NOT SUPPORT ONCHANGE EVENT SO I HAVE TO RESORT TO POLLING THE INPUT
    if (datepickerEls.length) {
      // THERE'S NO NEED TO CLEAR INTERVAL SINCE SUBMITTING THE FORM WILL REFRESH THE PAGE
      setInterval(() => {
        // console.log("Polling Date Inputs");
        const data = StoreService.get(formId);

        for (const el of datepickerEls) {
          const previousVal = data[el.name];
          const currentVal = el.value;
          // console.log({ previousVal, currentVal });
          // ENTER VALUE ONLY WHEN THERE"S VALUE TO SAVE
          if (currentVal && currentVal !== previousVal)
            data[el.name] = currentVal;
        }
        // console.log({ data });
        // console.log({ proposedSavedData: data });
        StoreService.save(formId, data);
      }, 10 * 1000);
    }
  } else {
    throw Error("Cannot use saveFormProgress fn without formId");
  }
}

// DELETE FORM PROGRESS DATA
export function clearFormProgress(formEl, formId) {
  // RESET FORM
  formEl.reset();
  // SELECT ALL SELECT2 DROPDOWNS AND RESET THEIR VALUE
  const selects = $("select");
  selects.each(function () {
    // FORT TIME PICKER RESET
    const name = $(this).attr("name");
    // console.log({ name });
    if (name && name.indexOf("_hour") !== -1) {
      // IF IT'S THE HOUR SELECTOR
      $(this).val("10").trigger("change");
    } else if (name && name.indexOf("_minute") !== -1) {
      // IF IT'S THE HOUR SELECTOR
      $(this).val("00").trigger("change");
    } else if (name && name.indexOf("_period") !== -1) {
      // IF IT'S THE HOUR SELECTOR
      $(this).val("AM").trigger("change");
    } else {
      // IF IT'S NOT A TIMEPICKER
      $(this).val("").trigger("change");
    }
  });

  if (formId) {
    StoreService.clearForm(formId);
  } else throw Error("Cannot use clearFormProgress fn without formId");
}

export function countUniquePrefix(obj, prefixes = []) {
  // INITIALIZE AN EMPTY OBJECT TO STORE UNIQUE PREFIXES
  // MAKE SURE AT LEAST 1 PREFIX IS RETURNED FOR EACH PREFIX PASSED IN
  const uniquePrefixes = [];

  // Iterate over the keys of the object
  for (let key in obj) {
    key = key.split("-")[0];
    // Check if the key starts with prefix and is not already in uniquePrefixes
    for (const prefix of prefixes) {
      if (key.startsWith(prefix) && !uniquePrefixes.includes(key)) {
        // Add the prefix to the uniquePrefixes array
        uniquePrefixes.push(key);
      }
    }
  }
  // MAKE SURE AT LEAST 1 PREFIX IS RETURNED FOR EACH PREFIX PASSED IN
  for (const prefix of prefixes)
    if (!uniquePrefixes.some((p) => p.startsWith(prefix)))
      uniquePrefixes.push(prefix + "1");

  return uniquePrefixes;
}
